export const PAYABLE_REQUEST = '/payable_request/';
export const PAYABLE_REQUEST_ID = id => `/payable_request/${id}/`;
export const PAYABLE_REQUEST_FINANCIAL_APPROVAL_ID = id =>
  `/payable_request/${id}/finnancial_approval/`;
export const PAYABLE_REQUEST_HOME_GROWN = '/payable_request_home_grown/';
